import type {
  PickupAddress,
  PickupTransportationMode,
  SchedulePickupRequest,
} from '../models/pickup.model';

/** Max length for the courier-facing `additionalInstructions` field. */
export const MAX_ADDITIONAL_INSTRUCTIONS_LENGTH = 120;

/** Fixed lead time (minutes) reserved between validation and the requested pickup window. */
const SCHEDULE_TIME_BUFFER_MINUTES = 30;

export interface BuildSchedulePickupRequestInput {
  pickupDate: string;
  currentLocalTime: string;
  pickupAddress: PickupAddress;
  transportationMode: PickupTransportationMode;
  destinationCode: string;
  pickUpAnyTimeAfter?: string;
  pickUpUntilTime?: string;
  pickUpLocationCode?: string;
  additionalInstructions?: string;
}

/**
 * Builds the `POST /pickup/schedule` request DTO.
 * `timeBuffer` is fixed at 30 minutes per the live contract.
 * `additionalInstructions` is included only when within 120 characters — never silently truncated.
 */
export function buildSchedulePickupRequest(
  input: BuildSchedulePickupRequestInput,
): SchedulePickupRequest {
  const request: SchedulePickupRequest = {
    pickupDate: input.pickupDate,
    currentLocalTime: input.currentLocalTime,
    pickupAddress: input.pickupAddress,
    transportationMode: input.transportationMode,
    destinationCode: input.destinationCode,
    timeBuffer: SCHEDULE_TIME_BUFFER_MINUTES,
  };

  if (input.pickUpAnyTimeAfter) {
    request.pickUpAnyTimeAfter = input.pickUpAnyTimeAfter;
  }

  if (input.pickUpUntilTime) {
    request.pickUpUntilTime = input.pickUpUntilTime;
  }

  if (input.pickUpLocationCode) {
    request.pickUpLocationCode = input.pickUpLocationCode;
  }

  if (
    input.additionalInstructions &&
    input.additionalInstructions.length <= MAX_ADDITIONAL_INSTRUCTIONS_LENGTH
  ) {
    request.additionalInstructions = input.additionalInstructions;
  }

  return request;
}
